<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col class="col-xl-2 col-md-12 d-fle align-self-center">
        <strong>IP 주소를 기반으로 국가 정보를 표시해요.</strong>
      </b-col>
      <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
        <b-form-group class="mt-3">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label variant="pill" size="sm" defaultChecked v-model="use_geoip" @change="change_use_geoip" :disabled="country_lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-form-group>
      </b-col>
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <strong>방화벽 모드 적용 국가를 선택해주세요</strong>
      </b-col>
      <b-col class="col-xl-5 col-md-12 align-self-center">
        <b-form-input :disabled="!use_geoip" style="display:inline-block" v-model="country" placeholder="Enter Country name"></b-form-input>
      </b-col>
      <b-col class="col-xl-1 col-md-12 align-self-center text-left">
        <b-form-checkbox :disabled="!use_geoip" v-model="select_all" @change="toggle_all">
          전체 선택
        </b-form-checkbox>
        <b-form-checkbox :disabled="!use_geoip" v-model="show_block_only" @change="save_show_status">
          선택만 표시
        </b-form-checkbox>
      </b-col>
       <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain_modal = true"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3 ml-3">
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <strong>선택된 국가</strong>
      </b-col>
      <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
        {{country_code.length}}
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col class="col-xl-12 col-md-12 align-self-center">
        <div class="pr-2 pl-2" v-show="(is_show(x) && !show_block_only) || (show_block_only && x.is_block)" v-for="(x, index) in country_info" :key="index" style="min-width:75px; height:75px; display:inline-block;">
          <b-form-checkbox :disabled="!use_geoip" style="cursor:pointer;" v-model="x.is_block" class="is_check" @change="onSelect(x.Code, x.Name)">
            <CountryFlag class="explain" style="cursor:pointer;"  :country="x.Code" size='normal'/>
            <p :style="x.is_block ? 'font-weight:900' : ''">{{ country ? x.Name : x.Code}}</p>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="국가 기반 차단"  class="modal-info" v-model="explain_modal" ok-variant="outline-primary" header-bg-variant="add" ok-title="확인" ok-only>
      <p>국가 코드 차단은 아이피를 국가로 변환 기능(GEO-IP)을 사용해야해요</p>
      <p>123.123.123.123 	&rArr; KR  </p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
